// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Compromissos_BuscaCompromissoResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for /compromissos/buscaCompromisso/{compromisso_id}
 *
 * Returns a single compromisso (appointment) with formatted datetime fields
 * and associated services.
 *
 * The response includes:
 * - Core compromisso fields (id, title, dates, status, etc.)
 * - Client information (id, name, phone, location)
 * - Franchise and location info (injected)
 * - Operator information
 * - Services list for this compromisso
 * - Financial status and amounts
 *
 * Datetime fields (start, end, compromisso_checkin, compromisso_checkout)
 * are formatted via translations->formatDate() for display.
 *
 * @see Compromissos_model::pega_compromisso()
 * @see Compromissos_model::pega_servicos_compromisso()
 * @see Compromissos::buscaCompromisso()
 */
import type { Compromissos_BuscaCompromissoOperadorRow } from './Compromissos_BuscaCompromissoOperadorRow'
import type { Compromissos_BuscaCompromissoServicoRow } from './Compromissos_BuscaCompromissoServicoRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Compromissos_BuscaCompromissoResponseDados {
servicos: Compromissos_BuscaCompromissoServicoRow[]
compromisso_id?: number
compromisso_titulo?: string
title?: string
compromisso_total?: string
compromisso_cor_fundo?: string
backgroundColor?: string
compromisso_data_hora_inicio?: string
start?: string
compromisso_data_hora_fim?: string
end?: string
compromisso_data_cadastro?: string
compromisso_operador_user_id?: string
compromisso_orcamento_id?: number
compromisso_franquia_id?: number
compromisso_forma_pagamento?: number
compromisso_forma_pagamento_label?: string
compromisso_numero_parcelas?: number
compromisso_nome_cliente?: string
compromisso_observacao?: string
compromisso_origem?: number
compromisso_status?: string
compromisso_status_original?: string
compromisso_tipo?: number
compromisso_checkin?: string
compromisso_checkout?: string
compromisso_entrou_sem_problemas?: number
compromisso_status_financeiro?: number
compromisso_valor_recebido?: string
cliente_id?: number
cliente_location_id?: number
cliente_location_type?: string
cliente?: string
franquia_nome?: string
localidade?: string
status_financeiro?: string
operador?: Compromissos_BuscaCompromissoOperadorRow
nome_operador?: string
avatar_operador?: string
borderColor?: string
franchise_id?: number
valor_restante?: number
valor_total?: number
compromisso_valor_total?: number
servicos_compromisso?: Compromissos_BuscaCompromissoServicoRow[]
}

export type Compromissos_BuscaCompromissoResponse = ApiResponse<Compromissos_BuscaCompromissoResponseDados>;

registerResponseContract('Compromissos_BuscaCompromissoResponse', {
  servicos: {
    type: 'array',
    required: true,
    items: {
      compromisso_servico_id:            { type: 'number',  required: true },
      compromisso_id:                    { type: 'number',  required: false },
      orcamento_servico_id:              { type: 'number',  required: false },
      compromisso_servico_status:        { type: 'number',  required: false },
      compromisso_servico_qtd:           { type: 'number',  required: false },
      compromisso_servico_valor:         { type: 'number',  required: false },
      compromisso_servico_data_cadastro: { type: 'string',  required: false },
      compromisso_servico_observacao:    { type: 'string',  required: false },
      servicoscategoria_id:              { type: 'number',  required: false },
      servico_id:                        { type: 'number',  required: false },
      servico_nome:                      { type: 'string',  required: false },
      tem_imagens_antes:                 { type: 'boolean', required: false },
      tem_imagens_depois:                { type: 'boolean', required: false },
    },
  },
  compromisso_id:                    { type: 'number',  required: false },
  compromisso_titulo:                { type: 'string',  required: false },
  title:                             { type: 'string',  required: false },
  compromisso_total:                 { type: 'string',  required: false },
  compromisso_cor_fundo:             { type: 'string',  required: false },
  backgroundColor:                   { type: 'string',  required: false },
  compromisso_data_hora_inicio:      { type: 'string',  required: false },
  start:                             { type: 'string',  required: false },
  compromisso_data_hora_fim:         { type: 'string',  required: false },
  end:                               { type: 'string',  required: false },
  compromisso_data_cadastro:         { type: 'string',  required: false },
  compromisso_operador_user_id:      { type: 'string',  required: false },
  compromisso_orcamento_id:          { type: 'number',  required: false },
  compromisso_franquia_id:           { type: 'number',  required: false },
  compromisso_forma_pagamento:       { type: 'number',  required: false },
  compromisso_forma_pagamento_label: { type: 'string',  required: false },
  compromisso_numero_parcelas:       { type: 'number',  required: false },
  compromisso_nome_cliente:          { type: 'string',  required: false },
  compromisso_observacao:            { type: 'string',  required: false },
  compromisso_origem:                { type: 'number',  required: false },
  compromisso_status:                { type: 'string',  required: false },
  compromisso_status_original:       { type: 'string',  required: false },
  compromisso_tipo:                  { type: 'number',  required: false },
  compromisso_checkin:               { type: 'string',  required: false },
  compromisso_checkout:              { type: 'string',  required: false },
  compromisso_entrou_sem_problemas:  { type: 'number',  required: false },
  compromisso_status_financeiro:     { type: 'number',  required: false },
  compromisso_valor_recebido:        { type: 'string',  required: false },
  cliente_id:                        { type: 'number',  required: false },
  cliente_location_id:               { type: 'number',  required: false },
  cliente_location_type:             { type: 'string',  required: false },
  cliente:                           { type: 'string',  required: false },
  franquia_nome:                     { type: 'string',  required: false },
  localidade:                        { type: 'string',  required: false },
  status_financeiro:                 { type: 'string',  required: false },
  operador: {
    type: 'object',
    required: false,
    fields: {
      first_name: { type: 'string',  required: false },
      image:      { type: 'string',  required: false },
    },
  },
  nome_operador:                     { type: 'string',  required: false },
  avatar_operador:                   { type: 'string',  required: false },
  borderColor:                       { type: 'string',  required: false },
  franchise_id:                      { type: 'number',  required: false },
  valor_restante:                    { type: 'number',  required: false },
  valor_total:                       { type: 'number',  required: false },
  compromisso_valor_total:           { type: 'number',  required: false },
  servicos_compromisso: {
    type: 'array',
    required: false,
    items: {
      compromisso_servico_id:            { type: 'number',  required: true },
      compromisso_id:                    { type: 'number',  required: false },
      orcamento_servico_id:              { type: 'number',  required: false },
      compromisso_servico_status:        { type: 'number',  required: false },
      compromisso_servico_qtd:           { type: 'number',  required: false },
      compromisso_servico_valor:         { type: 'number',  required: false },
      compromisso_servico_data_cadastro: { type: 'string',  required: false },
      compromisso_servico_observacao:    { type: 'string',  required: false },
      servicoscategoria_id:              { type: 'number',  required: false },
      servico_id:                        { type: 'number',  required: false },
      servico_nome:                      { type: 'string',  required: false },
      tem_imagens_antes:                 { type: 'boolean', required: false },
      tem_imagens_depois:                { type: 'boolean', required: false },
    },
  },
})
